import React, { useEffect, useMemo, useRef } from 'react';
import { Input, Icon } from 'tea-component';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import { getShowLabel, getCascaderLeafIdentity } from '../../../utils';
import { IChildProp, ICascaderSearchProps } from '@intelligence/components/Form/type';

const SEARCH_PLACEHOLDER = {
  label: 'Search',
  labelKey: 'dbi_label_search',
  value: 'search',
};

export default function CascaderSearch(props: ICascaderSearchProps) {
  // console.log(props);
  const { formatMessage } = useIntlExtend();
  const { selectedList = [], maxTagNum = 0, onTagClose = () => {}, onClear = () => {}, searchKey, setSearchKey, customDisplayRender, displayParentText, tagAutoWidth, tagWidth = 100, searchPlaceholder } = props;
  const searchInputRef = useRef<any>(null); // 当前选择区域

  const { targetList, restSelectedMarketLength } = useMemo(()=> {
    if (!maxTagNum || selectedList?.length <= maxTagNum) {
      return {
        targetList: selectedList,
        restSelectedMarketLength: 0,
      };
    }
    const targetList = selectedList.slice(0, maxTagNum);
    const restSelectedMarketLength = selectedList.length - maxTagNum;
    return {
      targetList,
      restSelectedMarketLength,
    };
  },[maxTagNum, selectedList]);

  const handleTagClose = (formItem: IChildProp) => {
    onTagClose(formItem);
  };

  const handleSearchWrapClick = () => {
    searchInputRef.current?.focus();
  };

  const handleSearch = (searchKey: string) => {
    setSearchKey(searchKey);
  };

  const handleSearchClear = () => {
    setSearchKey('');
    onClear();
  };

  const displayRender = (selectedItem: IChildProp, formatMessage: any) => {
    if (customDisplayRender && customDisplayRender instanceof Function) {
      return customDisplayRender({
        selectedItem,
        formatMessage,
        showLabelFormatFn: getShowLabel,
        tagAutoWidth,
        tagWidth,
        displayParentText
      });
    }
    return (
      <span style={{ maxWidth: tagAutoWidth ? 'unset' : tagWidth }}>{
        displayParentText
          ? `${getShowLabel(selectedItem.parent || {}, formatMessage)} - ${getShowLabel(selectedItem, formatMessage)}`
          : getShowLabel(selectedItem, formatMessage)
      }</span>
    );
  };

  useEffect(() => {
    handleSearchWrapClick();
  }, [selectedList.length]);

  return (
    <div className="dbi-cascader-search">
      <div className="dbi-cascader-search-wrap">
        <div
          className="dbi-cascader-search-wrap-inner"
          onClick={handleSearchWrapClick}
        >
          {targetList.map((item) => (
            <div
              className="tea-tag dbi-cascader-tag"
              key={getCascaderLeafIdentity(item)}
            >
              { displayRender(item, formatMessage) }
              <Icon
                onClick={() => {
                  handleTagClose(item);
                }}
                type="close"
              />
            </div>
          ))}
          {
            restSelectedMarketLength > 0 && (
              <div
                className="tea-tag dbi-cascader-tag"
                key={`rest-${restSelectedMarketLength}`}
              >
                <span style={{maxWidth: 'unset'}}>{`+${restSelectedMarketLength}`}</span>
              </div>
            )
          }
          <Input
            placeholder={searchPlaceholder || getShowLabel(SEARCH_PLACEHOLDER, formatMessage)}
            value={searchKey}
            ref={searchInputRef}
            className="dbi-cascader-search-input"
            type="text"
            onChange={(val) => handleSearch(val)}
          />
        </div>
        <div className="dbi-cascader-search-icon">
          {selectedList.length > 0 || searchKey ? (
            <Icon type="dismiss" onClick={handleSearchClear} />
          ) : null}
          <Icon type="search" />
        </div>
      </div>
    </div>
  );
}